exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-group-item[data-v-2c934d91] {\n  cursor: pointer;\n}\n.list-group-item[data-v-2c934d91]:hover {\n  background-color: #6a288a;\n  font-weight: 800;\n  color: white;\n}\n.selectedElementDiv[data-v-2c934d91] {\n  min-height: 80px;\n  padding-top: 10px;\n  background-color: lightgray;\n  border: 2px dotted black;\n}\n.selectedElementDiv h4[data-v-2c934d91] {\n  line-height: 80px;\n  color: white;\n  text-align: center;\n}\n.jsonContainer[data-v-2c934d91] {\n  background-color: whitesmoke;\n  border: 1px solid black;\n}\n", ""]);

// exports
